import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductForm from "../pages/ProductForm";
import { productApi } from "../api/productApi";

export default function ProductCreate() {
  const nav = useNavigate();
  const [saving, setSaving] = useState(false);

  const onSubmit = async (formData) => {
    setSaving(true);
    try {
      await productApi.create(formData);
      nav("/products");
    } catch (e) {
      alert(e?.response?.data || e.message || "Create failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="pageTitle">Məhsul əlavə et</h1>
      <ProductForm initial={null} onSubmit={onSubmit} submitText="Yadda saxla" saving={saving} />
    </div>
  );
}
